import React, { FC } from 'react'
import { ChannelTeamItem } from 'pages/native/onBoarding/types/types'
import { FollowButton, TeamLogo, TeamTitle } from './components'

import styles from './TeamListItem.module.scss'

interface TeamListItemProps {
  team: ChannelTeamItem
}

export const TeamListItem: FC<TeamListItemProps> = ({ team }) => {
  return (
    <div className={styles.ItemContainer}>
      <div className={styles.TeamDetails}>
        <TeamLogo team={team} />
        <TeamTitle title={team.name} />
      </div>
      <FollowButton team={team} />
    </div>
  )
}
